


const Footer = () => {
    return (
        <p></p>
    )
}

export default Footer;